import { render, staticRenderFns } from "./DatePickerWrapper.vue?vue&type=template&id=2108f22e&scoped=true"
import script from "./DatePickerWrapper.vue?vue&type=script&lang=ts"
export * from "./DatePickerWrapper.vue?vue&type=script&lang=ts"
import style0 from "./DatePickerWrapper.vue?vue&type=style&index=0&id=2108f22e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2108f22e",
  null
  
)

export default component.exports